import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useCloseTab } from '../../components/tabs/TabsContext'
import { PATTERN_PATH, addPattern } from '../../api/patternApi'
import { useApiProgress } from '../../hooks/ApiProgress'
import { addPatternAction } from '../../redux/feature/patternSlice'
import { toast } from 'react-toastify'
import { VALIDATION_MESSAGE } from '../../utils/constants'
import Input from '../../components/Input'
import { onChange } from '../../utils/functions'
import Textarea from '../../components/Textarea'
import Button from '../../components/Button'

const PatternSubmitPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const closeTab = useCloseTab()
    const dispatch = useDispatch()
    const [newPattern, setNewPattern] = useState({
        code: "",
        name: "",
        description: ""
    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('post', `${PATTERN_PATH}`, true)

    const onClickSubmit = () => {
        addPattern(newPattern)
            .then(res => {
                dispatch(addPatternAction(res.data))
                closeTab()
                toast.success('Desen kaydedildi')
            }).catch(err => {
                toast.error(VALIDATION_MESSAGE)
                setErrors(err.response.data.validationErrors)
            })
    }

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Yeni Desen</label>
                <Input
                    label='Desen Kodu'
                    name='code'
                    placeholder='Desen kodu girin'
                    error={errors.code}
                    onChange={e => onChange(e, setNewPattern, setErrors)}
                />
                <Input
                    label='Desen Adı'
                    name='name'
                    placeholder='Desen adı girin'
                    error={errors.name}
                    onChange={e => onChange(e, setNewPattern, setErrors)}
                />
                <Textarea
                    label='Açıklama'
                    name='description'
                    placeholder='Açıklama girin'
                    onChange={e => onChange(e, setNewPattern, setErrors)}
                />
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default PatternSubmitPage